import styled from 'styled-components';

export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 400px;
  max-width: 500px;
`;

export const ModalTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  color: #000000;
  margin: 0 0 10px 0;
`;

export const ModalInput = styled.input`
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 400;
  background-color: white;
  color: #374151;
  width: 100%;
  box-sizing: border-box;
  
  &::placeholder {
    color: #9CA3AF;
  }
  
  &:focus {
    outline: none;
    border-color: #10B981;
    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
  }
`;

export const ModalLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  display: block;
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 10px;
`;

export const CancelButton = styled.button`
  background-color: white;
  color: #374151;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  padding: 12px 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
  
  &:hover {
    background-color: #F9FAFB;
    border-color: #D1D5DB;
  }
`;

export const SaveButton = styled.button`
  background-color: #10B981;
  color: white;
  border: 1px solid #10B981;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  padding: 12px 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
  
  &:hover {
    background-color: #059669;
    border-color: #059669;
  }
`;